"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
// import clsx from 'clsx';
var NativeSelectInput_1 = __importDefault(require("./NativeSelectInput"));
var form_control_1 = require("@prezzee/form-control");
// import ArrowDropDownIcon from '../internal/svg-icons/ArrowDropDown';
var input_1 = __importDefault(require("@prezzee/input"));
var ArrowDropDownIcon = function () { return (0, jsx_runtime_1.jsx)("div", {}); };
var defaultInput = (0, jsx_runtime_1.jsx)(input_1.default, {});
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */
var NativeSelect = (0, react_1.forwardRef)(function (props, ref) {
    var className = props.className, children = props.children, 
    // classes: classesProp = {},
    _a = props.IconComponent, 
    // classes: classesProp = {},
    IconComponent = _a === void 0 ? ArrowDropDownIcon : _a, _b = props.input, input = _b === void 0 ? defaultInput : _b, inputProps = props.inputProps, variant = props.variant, other = __rest(props, ["className", "children", "IconComponent", "input", "inputProps", "variant"]);
    var formControl = (0, form_control_1.useFormControl)();
    return (0, react_1.cloneElement)(input, __assign({ 
        // Most of the logic is implemented in `NativeSelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: NativeSelectInput_1.default, inputProps: __assign(__assign({ children: children, 
            // classes: otherClasses,
            IconComponent: IconComponent, variant: formControl.variant, type: undefined }, inputProps), (input ? input.props.inputProps : {})), ref: ref }, other));
});
NativeSelect.displayName = 'PrezzeeNativeSelect';
exports.default = NativeSelect;
//# sourceMappingURL=NativeSelect.js.map